import React from "react";
import { Checkbox, Dialog, FormControlLabel, FormGroup } from "@mui/material";

import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper.jsx";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "views/pages/manage/common/constant";

import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { CheckIcon } from "./CheckIcon";
import { FailedIcon } from "./FailedIcon";

import { fetchReceiptDetails, sendNotification } from "./constants";

const NOTIFY_MODES = [
  {
    label: "Email",
    name: "email",
  },
  {
    label: "SMS",
    name: "sms",
  },
  {
    label: "Whatsapp",
    name: "whatsapp",
  },
];

const SendNotification = ({
  receiptDetails,
  open,
  handleCloseDialog,
  setIsGeneratingReceipt,
}) => {
  const [checked, setChecked] = React.useState({
    email: true,
    sms: true,
    whatsapp: true,
  });

  const [isNotifSent, setIsNotifSent] = React.useState(false);
  const [studentInfo, setResponse] = React.useState(null);
  const [notifResponse, setNotifResponse] = React.useState("");

  React.useEffect(() => {
    (async function () {
      const response = await fetchReceiptDetails([
        {
          receiptId: receiptDetails.receiptId,
          businessArea: receiptDetails.businessArea,
          businessAreaId: receiptDetails.buId,
        },
      ]);

      setResponse(response[0]);
    })();
  }, []);

  const FIELDS = React.useMemo(() => {
    return [
      {
        label: "Receipt ID",
        value: receiptDetails.receiptId,
      },
      {
        label: "PSID",
        value: receiptDetails.psid,
      },
      {
        label: "Mobile number",
        value: studentInfo?.studentPhoneNumber || "-",
      },
      {
        label: "Email ID",
        value: studentInfo?.studentEmailId || "-",
      },
    ];
  }, [studentInfo]);

  const isBtnDisabled = !Object.values(checked).some((val) => val);

  const handleChange = (event) => {
    setChecked({
      ...checked,
      [event.target.name]: event.target.checked,
    });
  };

  const handleSendNotification = async () => {
    setIsGeneratingReceipt(true);

    const s3response = await sendNotification({
      receiptsInfo: [studentInfo],
    });

    const payload = {
      notificationChannel: getSelectedModes(),
      psid: receiptDetails.psid,
      applicationId: receiptDetails.applicationId,
      opportunityOwnerId: receiptDetails.opportunityOwnerId,
      receiptNumber: receiptDetails.receiptId,
      s3Key: s3response?.key || null,
      businessAreaDisplayValue: receiptDetails.businessArea,
      term: receiptDetails.term,
      courseId: receiptDetails.courseId,
      courseType: receiptDetails.courseType,
    };

    if (s3response?.key) {
      //  if `receiptPdf` returns true, send reponse key to notify API
      const response = await fetchAllPostPromisedData(
        `${endpoint.manageReceipts.sendNotif}`,
        payload,
        "post"
      );

      setIsGeneratingReceipt(false);

      if (response?.code == 200) {
        setNotifResponse(response);
        setIsNotifSent(true);
      }

      return;
    }
    setIsGeneratingReceipt(false);
  };

  const getSelectedModes = () => {
    const channels = Object.entries(checked)
      .filter((arr) => arr[1])
      .map((item) => item[0].toUpperCase());
    return channels;
  };

  return (
    <>
      <Dialog onClose={handleCloseDialog} open={open}>
        <div style={{ padding: "22px 24px", width: "600px" }}>
          <header className="d-flex justify-content-between align-items-center">
            <h2 style={{ color: "#262626", fontFamily: "Gilroy-Medium" }}>
              Send Notification
            </h2>
            <IconButtonWrapper onClick={handleCloseDialog}>
              <CrossIcon />
            </IconButtonWrapper>
          </header>

          <p
            style={{
              fontWeight: "600",
              fontFamily: "Gilroy-Medium",
              marginBottom: 0,
            }}
          >
            Student details
          </p>

          <div
            className="d-flex flex-column justify-content-between py-2"
            style={{ borderBottom: "0.5px solid #757575" }}
          >
            {FIELDS.map(({ label, value }, index) => (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center"
              >
                <label className="text-sm">{label}</label>
                <strong style={{ fontFamily: "Gilroy-Medium" }}>{value}</strong>
              </div>
            ))}
          </div>

          <main>
            <p
              className="pt-3 pb-2 mb-0"
              style={{
                fontWeight: "600",
                fontFamily: "Gilroy-Medium",
              }}
            >
              Select mode
            </p>

            <FormGroup
              className="flex-row justify-content-between align-items-center"
              style={{ width: "90%" }}
            >
              {NOTIFY_MODES.map(({ label, name }) => (
                <FormControlLabel
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: "14px",
                      fontFamily: "Gilroy-Medium",
                    },
                  }}
                  key={label}
                  control={
                    <Checkbox
                      checked={checked[name]}
                      onChange={handleChange}
                      name={name}
                      style={{
                        color: "#00B0F5",
                      }}
                    />
                  }
                  label={label}
                />
              ))}
            </FormGroup>
          </main>

          <AButton
            variant="primary_filled"
            className="button_remove_left_margin mt-2 w-100"
            onClick={handleSendNotification}
            disabled={isBtnDisabled}
          >
            Send notification
          </AButton>
        </div>
      </Dialog>

      {isNotifSent && (
        <NotificationSuccessDialog
          isOpen={isNotifSent}
          handleCloseDialog={() => setIsNotifSent(false)}
          notifResponse={notifResponse}
          selectedModes={checked}
        />
      )}
    </>
  );
};

export default SendNotification;

const NotificationSuccessDialog = ({
  isOpen,
  handleCloseDialog,
  notifResponse,
  selectedModes,
}) => {
  React.useEffect(() => {
    // auto-close
    setTimeout(() => {
      handleCloseDialog();
    }, 4000);
  }, []);

  const isAllNotifFail = !notifResponse.data.some(
    ({ isNotificationSent }) => isNotificationSent
  );

  return (
    <Dialog
      onClose={handleCloseDialog}
      open={isOpen}
      classes={{
        paper: {
          borderRadius: "12px",
        },
      }}
    >
      <div style={{ padding: "22px 24px", width: "450px" }}>
        <h1
          style={{
            fontWeight: "600",
            fontFamily: "Gilroy-Medium",
            marginTop: "0.5rem",
          }}
        >
          {isAllNotifFail
            ? "Sending notification failed"
            : "Notification has been sent"}
        </h1>

        <p className="text-sm">{notifResponse.message}</p>

        {NOTIFY_MODES.map(({ label, name }) => {
          const renderedChannel = notifResponse.data.filter(
            ({ channel }) => channel.toLowerCase() === name
          );

          return (
            <div className="d-flex align-items-center mb-2">
              {renderedChannel.length &&
              renderedChannel[0].isNotificationSent ? (
                <CheckIcon />
              ) : selectedModes[name] ? (
                <FailedIcon />
              ) : (
                <CheckIcon color="#AFAFAF" />
              )}

              <span className="text-sm" style={{ marginLeft: "0.7rem" }}>
                {label}
              </span>
            </div>
          );
        })}
      </div>
    </Dialog>
  );
};
